import {
  Avatar,
  List,
  Typography,
  Space,
} from 'antd';
import React from 'react';
import { string } from 'prop-types';

const { Text } = Typography;

const CommentItem = ({
  authorName = '',
  avatarUrl = '',
  content = '',
  createdAt = '',
}) => (
  <List.Item>
    <List.Item.Meta
      avatar={<Avatar src={avatarUrl} />}
      title={(
        <Space>
          <Text strong>{authorName}</Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {createdAt}
          </Text>
        </Space>
      )}
      description={content}
    />
  </List.Item>
);

CommentItem.propTypes = {
  authorName: string,
  avatarUrl: string,
  content: string,
  createdAt: string,
};

export default CommentItem;
